import { Component, OnInit } from '@angular/core';

import { NaviService } from '../../services/navi.service';
import { RegisterService } from '../../services/register.service';

import { BasicError, Error409 } from '../../models/error/error';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})
export class ForgotpasswordComponent implements OnInit {
  public loginUrl: String = 'login';

  public sendPassword: Boolean = false;
  public infoOutput: String = '';
  public alertInfo: Boolean = false;

  public inpEmail: String = '';

  // Vars for Logo
  public imgLogo: String = 'assets/img/tinnituscare.png';
  public landingpageUrl: String = '/';

  constructor(private naviService: NaviService, private registerService: RegisterService) { }

  ngOnInit() {
  }


  public sendRequestForPassword() {
    if (this.inpEmail.search('@') === -1) {
      this.infoOutput = 'Geben Sie eine korrekte Email-Adresse an!';
      this.alertInfo = true;
    } else {
      this.registerService.requestPWResetInstructions(this.inpEmail).subscribe(data => {
        if (data instanceof BasicError) {
          console.log('There is an Error!');
          console.log(data);
          this.infoOutput = 'Das Versenden der Email ist fehlgeschlagen.';
          this.alertInfo = true;
        } else {
          this.infoOutput = 'Sie haben erfolgreich die Email angefordert.'
          this.alertInfo = true;
          this.sendPassword = true;
        }
      });

    }


  }

  public navigateToLogin() {
    this.naviService.navigateToUrl(this.loginUrl, 'login');
  }

  public navigateToLandingPage() {
    this.naviService.navigateToUrl(this.landingpageUrl, '');
  }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/forgotpassword/forgotpassword.component.ts